import styled from 'styled-components';

import { BaseLoading, CheckBoxGroup } from '@gbs-monorepo-packages/common';
import { colors, scrollbar } from '@gbs-monorepo-packages/styles';

import { FontCard } from '../../../../pages/EditCourse/components/FontCard';

export const FontCardCustom = styled(FontCard)``;
export const Container = styled(CheckBoxGroup)`
  display: flex;
  flex-direction: row;
  height: 100%;
  width: 100%;

  color: ${colors.blue300};
  & ${FontCardCustom} + ${FontCardCustom} {
    margin-top: 0.125rem;
  }
  max-height: calc((70vh - 60px) / 2);
`;

interface IFontCardCustomProps {
  selectedArea: boolean;
}

export const CardsContainer = styled.div<IFontCardCustomProps>`
  color: ${colors.blue300};
  display: flex;
  flex-direction: column;
  width: 100%;
  position: relative;
  overflow-y: auto;
  flex-grow: 1;

  ${scrollbar};
  &:not(:hover) {
    &::-webkit-scrollbar-thumb {
      visibility: hidden;
    }
  }
`;

export const CheckBoxCardContainer = styled.div`
  color: ${colors.blue300};
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
`;

export const Divider = styled.div`
  background-color: ${colors.divider};
  height: 100%;
  margin: 0.375rem 0;
  width: 1px;
`;

export const LabelNoFonts = styled.p`
  margin: 0.25rem;
  color: ${colors.black300};
  text-align: center;
`;

export const Loading = styled(BaseLoading)`
  height: 3.25rem;
  width: 3.25rem;
  margin-top: 1.5rem;
`;

export const LoadingContainer = styled.div`
  display: flex;
  flex-grow: 1;
  justify-content: center;
  margin-bottom: 2rem;
`;
